export default "__VITE_ASSET__BtRoR481__"